import * as actionTypes from './actionTypes';

export const fetchAllDefaultDashboards = () => ({
  type: actionTypes.FETCH_ALL,
});
export const fetchAllDefaultDashboardsSuccess = (ids) => ({
  type: actionTypes.FETCH_ALL_SUCCESS,
  ids,
});

export const createDefaultDashboard = (dashboard) => ({
  type: actionTypes.CREATE,
  dashboard,
});
export const createDefaultDashboardSuccess = (dashboard) => ({
  type: actionTypes.CREATE_SUCCESS,
  dashboard,
});

export const deleteDefaultDashboard = (dashboard) => ({
  type: actionTypes.DELETE,
  dashboard,
});
export const deleteDefaultDashboardSuccess = (id) => ({
  type: actionTypes.DELETE_SUCCESS,
  id,
});

export const updateDefaultDashboard = (dashboard) => ({
  type: actionTypes.UPDATE,
  dashboard,
});
export const updateDefaultDashboardSuccess = (id) => ({
  type: actionTypes.UPDATE_SUCCESS,
  id,
});

export const setActiveDefaultDashboardId = (id) => ({
  type: actionTypes.SET_ACTIVE_DASHBOARD_ID,
  id,
});

export const setActiveDefaultDashboardCurrentBreakpoint = (breakpoint) => ({
  type: actionTypes.SET_CURRENT_BREAKPOINT,
  breakpoint,
});
